import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { SvgIcon } from 'components/SvgIcon';
import Translate from 'components/Translate';
import ConfigCountry from 'components/Cart/ConfigCountry';
import { IProductData } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import { enProductType } from 'enums/enProductType';

const styles = require('./language.css');

interface IState extends IStateBase {
  cart: IProductData;
}

export default class Language extends BaseComponent<IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      cart: null
    };
  }

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
  }

  hideLang = (): boolean => {
    const { cart } = this.state;

    if ((!cart.config.enableCreditcard && !cart.config.enablePaypal && cart.config.enableBankslip)
      || !cart.foreignEnabled
      || cart.config.productType === enProductType.PHYSICAL
      || cart.availableCurrencies.length === 1) {
      return true;
    }

    return false;
  }

  render() {

    const { cart } = this.state;

    if (!cart) {
      return null;
    }

    return (
      <div className={`${styles.component} theme-language-bar`}>
        <div className='chk-wrapper'>
          <div className='chk-language__logo'>
            <SvgIcon name='checkoutLogo' />
            <span>Checkout Sun</span>
          </div>
          {!this.hideLang() ?
            <div className='chk-language__selectLanguage'>
              <Translate term='Selecionar Região:' />
              <ConfigCountry />
            </div> : null
          }
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Language/index.tsx